// Libs
import styled from 'styled-components'

// Comps
import { EventHookInterface, Option } from '../../../types'
import { EventSizeField } from './EventSizeField'
import { ConferencingField } from './ConferencingField'
import { EventTicketField } from './EventTicketField'
import { show } from '../../../utils'

// Props.
interface Props {
  eventHook: EventHookInterface
  groupId?: number
}

// A group of editable fields used for creating or editing an event
export const DropdownFields: React.FC<Props> = (props) => {
  // Props
  const { eventHook, groupId } = props
  const event = eventHook.value

  // ..
  return (
    <>
      {/* Event admission - Event Tickets */}
      {show(eventHook.isEditable === true) && (
        <>
          <EventTicketField eventHook={eventHook} groupId={groupId} />
        </>
      )}

      {/* Event Public/unlisted & category */}
      {show(eventHook.isEditable === true) && (
        <>
          <EventSizeField eventHook={eventHook} />
        </>
      )}

      {/* Video call setup - Add Conferencing.  */}
      {show(
        eventHook.isEditable === true ||
          (eventHook.isEditable === false &&
            (event.is_user_host || event.is_user_going)),
      ) && (
        <>
          <ConferencingField eventHook={eventHook} />
        </>
      )}
    </>
  )
}
